import { useState, useEffect } from 'react';

export const useLocalizedStore = () => {
  const [localizedStoreId, setLocalizedStoreId] = useState(null);
  const getLocalizedStoreId = () => window?.THD_LOCALIZER_AUTO_INIT?.Localizer?.getLocalizedStore()?.storeId ?? null;
  // isUserDefaultLocalized checks if localization was successful.
  // if true, it means localization was not successful and default to store 121.
  // if false, it means localization was successful and we can use the localized store id.
  const isUserDefaultLocalized = () => window?.THD_LOCALIZER_AUTO_INIT?.Localizer?.status?.isDefaultLocalized() ?? true;

  useEffect(() => {
    const storeId = getLocalizedStoreId();
    if (!isUserDefaultLocalized()) {
      setLocalizedStoreId(storeId);
    }
  }, []);

  return localizedStoreId;
};
